import { ModelMixin } from '../core/base-generic.model';

export type ImportStatus = 'skipped' | 'error' | 'waiting' | 'success';
const DISABLED_STATUSES = ['error', 'skipped'];

export class ImportIntegrationEmployee extends ModelMixin<ImportIntegrationEmployee>() {
    protected static _type = 'integration_employee';

    protected static _resource = 'integration/employees/import/:integrationId';

    protected static _version = 'v2';

    constructor(res?: object | object[]) {
        super(res);
        if (DISABLED_STATUSES.includes(this.importStatus)) {
            this._attributes['disabled'] = true;
        }
    }

    get firstName(): string {
        return this._attributes['legalFirstName'];
    }
    get lastName(): string {
        return this._attributes['legalLastName'];
    }
    get email(): string {
        return this._attributes['email'];
    }
    get title(): string {
        return this._attributes['position'];
    }
    get department(): string {
        return this._attributes['department'];
    }
    get hiredAt(): Date {
        return this._attributes['startDate'];
    }
    get rolePermission(): string {
        return this._attributes['role'];
    }
    get employmentType(): string {
        return this._attributes['employmentType'];
    }
    get officeName(): string {
        return this._attributes['officeName'];
    }

    get importStatus(): ImportStatus {
        return this._attributes['status'].toLowerCase() ?? 'skipped';
    }
}
